var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('notifications',{attrs:{"group":"alerts","position":"bottom right"}}),_vm._v(" "),_c('notifications',{staticStyle:{"top":"57px !important"},attrs:{"group":"notifications","position":"top left"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }